import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  createServiceModalToggle: false,
  editServiceModalToggle: false,
  addCompanyServiceModalToggle: false,
  editCompanyServiceModalToggle: false,
  styleGuideServiceModalToggle: false,
  styleGuildeServiceModalToggle: false,
  allServices: [],
  createService: {},
  service: {},
  customerService: {},
  updateService: {},
  deleteService: {},
  serviceTasks: [],
  createServiceTask: {},
  updateServiceTask: {},
  deleteServiceTask: {},
  allcustomerServiceReport: [],
  allServicesOfCustomer: [],
  addServiceToCustomer: {},
  updateCustomerService: {},
  deleteCustomerService: {},
  isAllServiceLoading: false,
  isServiceLoading: false,
  addServiceModalToogle: false,
  isLoading: false,
  error: [],
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = [];
      state.isLoading = false;
    },
    getAllServicesStart: (state, action) => {
      state.isAllServiceLoading = true;
      state.error = [];
      state.isLoading = false;
    },
    getServiceByIdStart: (state, action) => {
      state.isAllServiceLoading = true;
      state.error = [];
      state.isLoading = false;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setCustomerService: (state, action) => {
      state.customerService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAllServices: (state, action) => {
      state.allServices = action.payload;
      state.error = [];
      state.isAllServiceLoading = false;
    },
    setCreateService: (state, action) => {
      state.createService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setService: (state, action) => {
      state.service = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUpdateService: (state, action) => {
      state.updateService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setDeleteService: (state, action) => {
      state.deleteService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setServiceTasks: (state, action) => {
      state.serviceTasks = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setCreateServiceTask: (state, action) => {
      state.createServiceTask = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUpdateServiceTask: (state, action) => {
      state.updateServiceTask = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setDeleteServiceTask: (state, action) => {
      state.deleteServiceTask = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAllcustomerServiceReport: (state, action) => {
      state.allcustomerServiceReport = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAllServicesOfCustomer: (state, action) => {
      state.allServicesOfCustomer = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAddServiceToCustomer: (state, action) => {
      state.addServiceToCustomer = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUpdateCustomerService: (state, action) => {
      state.updateCustomerService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setDeleteCustomerService: (state, action) => {
      state.deleteCustomerService = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setCreateServiceModalToggle: (state, action) => {
      state.createServiceModalToggle = !state.createServiceModalToggle;
    },
    setEditServiceModalToggle: (state, action) => {
      state.editServiceModalToggle = !state.editServiceModalToggle;
    },
    setAddCompanyServiceModalToggle: (state, action) => {
      state.addCompanyServiceModalToggle = !state.addCompanyServiceModalToggle;
    },
    setEditCompanyServiceModalToggle: (state, action) => {
      state.editCompanyServiceModalToggle = !state.editCompanyServiceModalToggle;
    },
    setStyleGuideServiceModalToggle: (state, action) => {
      state.styleGuideServiceModalToggle = !state.styleGuideServiceModalToggle;
    },
    setAddServiceModalToggle: (state, action) => {
      state.addServiceModalToogle = !state.addServiceModalToogle;
    },
    setResetServices: () => {
      return initialState;
    },
  },
});

export const {
  start,
  getAllServicesStart,
  getServiceByIdStart,
  setReducerError,
  setAddServiceModalToggle,
  setCustomerService,
  setAllServices,
  setCreateService,
  setService,
  setUpdateService,
  setDeleteService,
  setServiceTasks,
  setCreateServiceTask,
  setUpdateServiceTask,
  setDeleteServiceTask,
  setAllcustomerServiceReport,
  setAllServicesOfCustomer,
  setAddServiceToCustomer,
  setUpdateCustomerService,
  setDeleteCustomerService,
  setCreateServiceModalToggle,
  setEditServiceModalToggle,
  setAddCompanyServiceModalToggle,
  setEditCompanyServiceModalToggle,
  setStyleGuideServiceModalToggle,
  setResetServices,
} = servicesSlice.actions;

export default servicesSlice.reducer;
